import { createSelector } from 'reselect'
import { convertGidToRaw } from 'util/scatterSwap'
import { selectCurrentTicketMailboxId } from './selectCurrentTicketMailboxId'

export const selectCurrentTicketRawMailboxId = createSelector(
  selectCurrentTicketMailboxId,
  mailboxId => (mailboxId ? convertGidToRaw(mailboxId) : null)
)
